/**
 * External Dependencies
 */
import React from 'react';

/**
 * Internal Dependencies
 */
import PageContent from '../../components/page-content';
import PageTitle from '../../components/page-title';
import PageWrap from '../../components/page-wrap';
import InformativaContent from './content';

/**
 * Component
 */
const Informativa = () => {
  return (
    <PageWrap>
      <PageTitle
        breadcrumbs={{
          '/': 'Home',
        }}
      >
        <h1>Informativa</h1>
      </PageTitle>
      <PageContent>
        <InformativaContent />
      </PageContent>
    </PageWrap>
  );
};

export default Informativa;
